export const REQUIRE_SECURITY_DEPOSIT = 'REQUIRE_SECURITY_DEPOSIT';
export const WAIVE_SECURITY_DEPOSIT = 'WAIVE_SECURITY_DEPOSIT';
